import remove from 'lodash/remove';
import filter from 'lodash/filter';

import { SystemCamera } from '../System/systemCamera';
import { ShaderCamera } from '~src/Material/Camera/shaderCamera';
import { ElementEvent, ElementsManager } from '~src/Element/elementsManager';
import { ShaderInteraction, EVENT } from '~src/Material/Shader/shaderInteraction';
import { InteractionOptions } from './interactionElements';
import { Interaction } from './interaction';

export class InteractionManagerPlay {
    private browser: HTMLElement;

    protected system: SystemCamera;

    protected elementsManager: ElementsManager;

    protected shaderCamera: ShaderCamera;

    public _interactions: Interaction[] = [];

    constructor(
        browser: HTMLElement,
        system: SystemCamera,
        elementsManager: ElementsManager,
        shaderCamera: ShaderCamera
    ) {
        this.system = system;
        this.browser = browser;
        this.elementsManager = elementsManager;
        this.shaderCamera = shaderCamera;

        this.elementsManager.on(ElementEvent.Added, () => {
            this.checkElementsInInteractions();
        });

        this.elementsManager.on(ElementEvent.Removed, (element) => {
            this.removeElementFromInteractions(element);
        });
    }

    protected getInteractionByEvent(event: EVENT): Interaction[] {
        return filter(this._interactions, (a) => a.event === event);
    }

    protected setInteraction(interactionOptions: InteractionOptions): Interaction {
        const interaction = new Interaction(
            this.system,
            this.browser,
            this.elementsManager,
            this.shaderCamera,
            interactionOptions
        );
        this._interactions.push(interaction);
        interaction.checkInteractionElements();
        interaction.checkSteps();
        return interaction;
    }

    protected unsetInteraction(interaction: Interaction) {
        remove(this._interactions, (i) => i === interaction);
    }

    public checkElementsInInteractions() {
        this._interactions.forEach((interaction) => {
            interaction.checkInteractionElements();
        });
    }

    public checkInteractionElementsAndUpdate() {
        this._interactions.forEach((interaction) => {
            interaction.checkInteractionElementsAndUpdate();
        });
    }

    public removeElementFromInteractions(element: ShaderInteraction) {
        this._interactions.forEach((interaction) => {
            remove(interaction.elements, (e) => e === element);
            element.killTimelines();
        });
    }

    protected getInteractionElementByEvent(
        element: ShaderInteraction,
        event: EVENT
    ): Interaction {
        const eventInteractions = this.getInteractionByEvent(event);
        let interactionByEvent = null;
        eventInteractions.forEach((interaction) => {
            if (interaction.elements.includes(element)) {
                interactionByEvent = interaction;
            }
        });
        return interactionByEvent;
    }

    public checkElementsAttributes() {
        const { elements } = this.elementsManager;
        elements.forEach((element) => {
            element.checkAttributes();
        });
    }
}
